export function useAuthCatchErrors () {
  function catchError (e): string {
    if (typeof e.errors === 'string') return e.errors
    if (Array.isArray(e.errors)) return e.errors.join(', ')
    if (e.errors && typeof e.errors === 'object') {
      if (e.errors.wait_seconds || e.errors.waitSeconds) {
        return e.message
      }
      const first = Object.values(e.errors as Record<string, string[] | string>)[0]
      return Array.isArray(first) ? first[0] : String(first)
    }
    return e.message
  }

  return {
    catchError
  }
}
